export const state = () => {
	return {
		store: {},
		userGroups: [],
		currencies: [],
		ttl_store: null,
		cache_duration_store: 3600000, // 1 heure
		cache_key_store: '',
	}
}

function isInCacheStore(state, companyId) {
	if (state.cache_key_store !== buildCacheKeyStore(companyId)) {
		return false
	}
	if (state.ttl_store === null || state.ttl_store < Date.now()) {
		return false
	}
	return true
}

function buildCacheKeyStore(companyId) {
	return 'company:' + companyId + ':stores'
}

export const getters = {
	hasStore: ({ store }) => !!store && Object.keys(store).length > 0,
	isShopify: ({ store }, { hasStore }) => hasStore && store.provider === 1,
	isPrestashop: ({ store }, { hasStore }) => hasStore && store.provider === 2,
}

export const actions = {
	async list({ state, commit }, { companyId }) {
		if (isInCacheStore(state, companyId)) {
			return state.store
		}
		return await useNuxtApp()
			.$api(`api/company/${companyId}/stores/`)
			.then((res) => {
				if (res.length === 0) {
					commit('setStore', { data: {}, companyId })
					return {}
				}
				commit('setStore', { data: res[0], companyId })
				return res[0]
			})
			.catch((err) => {
				commit('clearCacheStore')
				throw err
			})
	},

	async oauthUrl(_, { companyId }) {
		return await useNuxtApp()
			.$api(`api/company/${companyId}/stores/oauth-url/`, { method: 'POST' })
			.then((res) => {
				return res.oauth_url
			})
			.catch((err) => {
				throw err
			})
	},

	async products(_, { companyId, params }) {
		return await useNuxtApp()
			.$api(`api/company/${companyId}/stores/products/`, { params })
			.then((res) => {
				return res
			})
			.catch((err) => {
				throw err
			})
	},

	async retrieveProducts(_, { companyId, productId }) {
		return await useNuxtApp()
			.$api(`api/company/${companyId}/stores/products/${productId}/`)
			.then((res) => {
				return res
			})
			.catch((err) => {
				throw err
			})
	},

	async retrieveProductVariants(_, { companyId, productId }) {
		return await useNuxtApp()
			.$api(`api/company/${companyId}/stores/product/${productId}/variants/`, {})
			.then((res) => {
				return res
			})
			.catch((err) => {
				throw err
			})
	},

	async collections(_, { companyId, params }) {
		return await useNuxtApp()
			.$api(`api/company/${companyId}/stores/collections/`, { params })
			.then((res) => {
				return res
			})
			.catch((err) => {
				throw err
			})
	},

	async retrieveCollections(_, { companyId, collectionId }) {
		return await useNuxtApp()
			.$api(`api/company/${companyId}/stores/collections/${collectionId}/`, {})
			.then((res) => {
				return res
			})
			.catch((err) => {
				throw err
			})
	},

	async createWithoutCompany({ commit }, { params }) {
		return await useNuxtApp()
			.$api(`api/company/0/stores/create-shopify/`, { method: 'POST', body: params })
			.then((res) => {
				useCookie('auth', {
					expires: new Date(new Date().getTime() + 1000 * 3600 * 24 * 365),
					path: '/app/',
				}).value = res
				useCookie('token', {
					expires: new Date(new Date().getTime() + 1000 * 3600 * 24 * 365),
					path: '/',
				}).value = res.token
				useCookie('refresh_token', {
					expires: new Date(new Date().getTime() + 1000 * 3600 * 24 * 365),
					path: '/',
				}).value = res.refresh_token
				useCookie('access_token', {
					expires: new Date(new Date().getTime() + 1000 * 3600 * 24 * 365),
					path: '/',
				}).value = res.access_token
				commit('setAuth', res, { root: true })
				return res
			})
			.catch((err) => {
				throw err
			})
	},

	async createPrestashop({ commit }, { companyId, params }) {
		return await useNuxtApp()
			.$api(`api/company/${companyId}/stores/create-prestashop/`, {
				method: 'POST',
				body: params,
			})
			.then((res) => {
				commit('setStore', { data: res, companyId })
			})
			.catch((err) => {
				throw err
			})
	},

	async oauthUrlShopify(_, { params }) {
		return await useNuxtApp()
			.$api(`api/company/0/stores/oauth-url-shopify/`, { method: 'POST', body: params })
			.then((res) => {
				return res.oauth_url
			})
			.catch((err) => {
				throw err
			})
	},

	async retrieveUserGroups({ commit }, { companyId }) {
		return await useNuxtApp()
			.$api(`api/company/${companyId}/stores/user-groups/`)
			.then((res) => {
				commit('setUserGroups', res)
				return res
			})
			.catch((err) => {
				throw err
			})
	},

	async retrieveCurrencies({ commit }, { companyId }) {
		return await useNuxtApp()
			.$api(`api/company/${companyId}/stores/currency/`)
			.then((res) => {
				commit('setCurrencies', res)
				return res
			})
			.catch((err) => {
				throw err
			})
	},
}

export const mutations = {
	setStore(state, { data, companyId }) {
		state.store = data
		state.ttl_store = Date.now() + state.cache_duration_store
		state.cache_key_store = buildCacheKeyStore(companyId)
		state.userGroups = []
	},

	setUserGroups(state, data) {
		state.userGroups = data
	},

	setCurrencies(state, data) {
		state.currencies = data
	},

	clearCacheStore(state) {
		state.store = {}
		state.ttl_store = null
		state.cache_key_store = ''
		state.userGroups = []
	},

	invalidateCacheStore(state) {
		state.ttl_store = null
	},
}
